export const userSelector = state => state.user;